module.exports = __webpack_public_path__ + "static/media/login-bg.cb1873c8.png";